import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// import Paper from '@mui/material/Paper';
// import Draggable from 'react-draggable';
import ButtonAction from '../Button.js/SaveButton';
import { useTranslation } from 'react-i18next';
import { Alert, Typography } from '@mui/material';
// function PaperComponent({ ...props }) {
//     return (
//         <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
//             <Paper {...props} />
//         </Draggable>
//     );
// }

export default function ConfirmMessages({ visible = false, setVisible, handleSave, loader, title, mesages }) {
    const { t } = useTranslation();

    return (
        <div>
            <Dialog open={visible} onClose={() => setVisible(false)} aria-labelledby="draggable-dialog-title">
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    {mesages}
                    <Alert sx={{ alignItems: 'flex-start' }} severity="warning" style={{ marginTop: '20px' }}>
                        <div>
                            <Typography fontWeight="lg" sx={{ fontWeight: '600', fontSize: '17px' }} mt={0.25}>
                                {t('note')}
                            </Typography>
                            <Typography fontSize="sm" sx={{ opacity: 0.8 }}>
                                {t('note_confirm_import_excel')}
                            </Typography>
                        </div>
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <ButtonAction
                        title={t('cancel')}
                        onClick={() => setVisible(false)}
                        // variant="text"
                        type="cancel"
                    />
                    <ButtonAction title={t('continue')} type="save" onClick={handleSave} />
                </DialogActions>
            </Dialog>
        </div>
    );
}
